import React, { useId, useState } from 'react';
import { Bell, Download } from 'lucide-react';
import './player-action-nudge.css';

/** Presentation only. Permission, subscription and install logic stay in PlayerApp. */
export default function PlayerActionNudge({
  variant, title, description, status, actionLabel, onAction, busy = false,
  brandLogo, phase = 'visible', exitDuration = 1400, testId,
}) {
  const id = useId();
  const [artFailed, setArtFailed] = useState(false);
  const [logoFailed, setLogoFailed] = useState(false);
  const install = variant === 'install';
  const FallbackIcon = install ? Download : Bell;

  return (
    <section
      className={`player-home-nudge-item player-action-nudge player-action-nudge--${variant}${phase === 'leaving' ? ' player-home-nudge-item--leaving' : ''}`}
      style={{ '--player-home-nudge-exit-duration': `${exitDuration}ms` }}
      data-testid={testId}
      aria-labelledby={`${id}-title`}
      aria-busy={busy}
      inert={phase === 'leaving'}
    >
      <span className="player-action-nudge__art" aria-hidden="true">
        {artFailed ? <FallbackIcon size={30} /> : (
          <img
            src={`/assets/player-actions/${install ? 'app-download' : 'notification-bell'}-v1.png`}
            alt="" width="60" height="60" decoding="async"
            onError={() => setArtFailed(true)}
          />
        )}
        {install && brandLogo && !logoFailed && (
          <img className="player-action-nudge__brand" src={brandLogo} alt="" width="22" height="22" onError={() => setLogoFailed(true)} />
        )}
      </span>
      <button
        type="button" className="player-action-nudge__copy"
        onClick={onAction} disabled={busy}
        aria-describedby={`${id}-description`}
        data-testid={`${testId}-button`}
      >
        <span className="player-action-nudge__title" id={`${id}-title`}>{title}</span>
        {status && <span className="player-action-nudge__status" role="status">{status}</span>}
        <span className="player-action-nudge__description" id={`${id}-description`}>{description}</span>
      </button>
      <button
        type="button" className="player-action-nudge__action"
        onClick={onAction} disabled={busy}
        aria-label={`${actionLabel} ${install ? 'app' : 'notifications'}`}
        aria-describedby={`${id}-description`}
        data-testid={`${testId}-cta`}
      >
        {actionLabel}
      </button>
    </section>
  );
}
